import { render, staticRenderFns } from "./DocumentTemplateDetailSignature.vue?vue&type=template&id=0711b01c&scoped=true&"
import script from "./DocumentTemplateDetailSignature.vue?vue&type=script&lang=ts&"
export * from "./DocumentTemplateDetailSignature.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentTemplateDetailSignature.vue?vue&type=style&index=0&id=0711b01c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711b01c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VForm,VImg,VSimpleTable,VSkeletonLoader,VTextField,VTextarea})
